import useStore from "../../../store"
import CreditAvailable from "./CreditAvailable"
import { useTranslation } from 'react-i18next'
import { Widget, WidgetBody, WidgetHeader } from "../../ui/Widget"

export default function CreditUtilization() {
  const dealer = useStore((state) => state.dealer)
  const { t } = useTranslation()

  return(
    <Widget>
        <WidgetHeader
          title={t('Credit Available')}
          showSpinner={!dealer}
        />
        <WidgetBody isVisible={!!dealer}>
            <CreditAvailable />
        </WidgetBody>
    </Widget>
  )
}